import React from 'react';
import Editor from '@monaco-editor/react';

export function CodeEditorPanel({ code, onChange }) {
  return (
    <div className="code-editor-panel">
      <Editor
        height="420px"
        language="javascript"
        theme="vs-dark"
        value={code}
        onChange={(value) => onChange(value ?? '')}
        options={{
          minimap: { enabled: false },
          fontSize: 13,
          tabSize: 2,
          scrollBeyondLastLine: false,
          automaticLayout: true,
        }}
      />
    </div>
  );
}
